import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { CombinedFeedbackDataArray } from '@mopla/data-models';

import { CoinIcon } from '../../icons';
import { MplRating, TRating } from '../MplRating';

interface IRatedContentProps {
	feedbackDataArray: CombinedFeedbackDataArray;
}

export const RatedContent: FC<IRatedContentProps> = ({ feedbackDataArray }) => {
	const { t } = useTranslation('booking');

	return (
		<Stack gap={0.5}>
			{feedbackDataArray.map(({ driverCarDetails, feedback, legId }) => {
				const { rating } = feedback ?? {};
				const { carLicensePlate, displayName } = driverCarDetails;

				if (!rating) {
					return null;
				}

				return (
					<Fragment key={legId}>
						<Typography
							variant="body2"
							children={t('feedback.driver', {
								fullName: displayName,
								carId: carLicensePlate,
							})}
						/>
						<MplRating
							disabled
							suggestionPosition="right"
							value={rating as TRating}
						/>
						<Stack direction="row" gap={1} alignItems="center">
							<CoinIcon color="neutral.80" />
							<Typography
								variant="body2"
								children={t('feedback.tip_empty')}
								// TODO: Uncomment when the Tip data will be available
								// children={
								// 	tip
								// 		? t('feedback.tip_value', {
								// 				value: formatPrice(tip),
								// 		  })
								// 		: t('feedback.tip_empty')
								// }
							/>
						</Stack>
					</Fragment>
				);
			})}
		</Stack>
	);
};
